<div
        class="{{class}} no-mat-mdc-form-field-subscript-wrapper position-relative overflow-x-hidden dark:bg-gray-800 dark:text-gray-300"
>
    <!-- Search Fields -->
    <ng-container *ngIf="showSearchFields">
        <ng-container *ngIf="showFilters || showSearchStates || showSearchInput || showDateFilter || showDateRangeFilter">
            <!-- Generic Search Inputs and Predefined States -->
            <div
                    *ngIf="(dataLength > 9) || hasTouchedSearchInput || alwaysShowFilter || hasActiveStates()"
                    [style.--order]="2.2"
                    class="mt-2 mb-1 {{animation}} {{filtersContainerClass}} dark:border-gray-700 dark:bg-gray-800"
            >
                <data-states
                        (change)="searchCustomState($event)"
                        (clearSearchStates)="clearSearchCustomState()"
                        (searchInputChange)="updateSearchInputStates($event)"
                        [searchByMultipleKeys]="searchByMultipleKeys"
                        [searchInputStates]="searchInputStates"
                        [searchKeys]="searchKeys"
                        [showSearchInput]="showSearchInput"
                        [showSearchStates]="showSearchStates"
                        [states]="searchStates"
                ></data-states>

                <!-- Status Filters -->
                <div *ngIf="statusFilters" class="place-self-end flex justify-center">
                    <mat-form-field
                            appearance="outline"
                            class="material-form move-up --order-3 m-2 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
                            *ngFor="let select of dropDownData; index as i"
                    >
                        <mat-select
                                [multiple]="multipleSelect[i]"
                                [placeholder]="placeholder[i]"
                                (selectionChange)="setTableDataFromQuery(query, $event, i)"
                        >
                            <mat-option *ngFor="let data of select" [value]="data?.uid ?? data?.name">
                                {{ data[dropDownSelectKey[i]] }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!-- Date Filters -->
            <div
                    *ngIf="dateFilterKeys.length && (showDateFilter || showDateRangeFilter)"
                    [style.--order]="2.2"
                    class="{{filtersContainerClass}} {{animation}} dark:border-gray-700 dark:bg-gray-800"
            >
                <!-- Date Range -->
                <date-filter
                        (cancel)="clearDateRangeFilter()"
                        (endDateChange)="endDateValue = $event"
                        (labelClick)="filterByDateRange()"
                        (selectedKeyChange)="selectedDateRangeKey = $event"
                        (startDateChange)="startDateValue = $event; log($event)"
                        *ngIf="showDateRangeFilter"
                        [dateRange]="true"
                        [date]="startDateValue"
                        [endDate]="endDateValue"
                        [keys]="dateFilterKeys"
                        [order]="5.5"
                        [selectedKey]="selectedDateRangeKey"
                        icon="search"
                        iconClass="icon-small text-primary top-2"
                        label="Search Range"
                        type="select"
                        class="dark:bg-gray-700 dark:text-gray-300"
                ></date-filter>

                <!-- Single Date Filter -->
                <date-filter
                        (cancel)="clearFilterDate()"
                        (change)="filterByDate($event)"
                        (selectedKeyChange)="selectedDateKey = $event"
                        *ngIf="showDateFilter"
                        [date]="dateValue"
                        [keys]="dateFilterKeys"
                        [order]="5.5"
                        [selectedKey]="selectedDateKey"
                        type="select"
                        class="dark:bg-gray-700 dark:text-gray-300"
                ></date-filter>
            </div>
        </ng-container>

        <!-- Table Controls -->
        <div
                *ngIf="showTableControls"
                [style.--order]="2.2"
                class="{{filtersContainerClass}} {{animation}} dark:border-gray-700 dark:bg-gray-800"
        >
            <mat-checkbox (change)="updateXpCol()" [(ngModel)]="expandable"> Row Expandable </mat-checkbox>
            <mat-checkbox [(ngModel)]="multiSelectable"> Multi Selectable </mat-checkbox>
            <mat-checkbox [(ngModel)]="rowSelectable"> Row Selectable </mat-checkbox>
            <mat-checkbox [(ngModel)]="hideRowSelectionCheckbox"> Hide checkbox </mat-checkbox>
            <mat-checkbox [(ngModel)]="showToolbar"> Show Toolbar </mat-checkbox>
            <mat-checkbox [(ngModel)]="columnHideable"> Column Hiding </mat-checkbox>
            <mat-checkbox [(ngModel)]="columnSortable"> Column Sorting </mat-checkbox>
            <mat-checkbox [(ngModel)]="columnPinnable"> Column Pinning </mat-checkbox>
            <mat-checkbox [(ngModel)]="rowHover"> Hover </mat-checkbox>
            <mat-checkbox [(ngModel)]="rowStriped"> Striped </mat-checkbox>
            <mat-checkbox [(ngModel)]="showPaginator"> Show Paginator </mat-checkbox>
            <mat-checkbox [(ngModel)]="isLoading"> Loading Status </mat-checkbox>
            <mat-checkbox [(ngModel)]="columnResizable"> Column Resizable </mat-checkbox>
            <mat-checkbox [(ngModel)]="contentEditable"> Content Editable </mat-checkbox>
        </div>
    </ng-container>

    <!-- Data Grid -->
    <div
            *ngIf="visibleItemsMod?.length || listData?.data?.length; else noDataTpl"
            class="m-1 my-2 pt-0 {{animation}} dark:bg-gray-800 dark:text-gray-300"
            style="--order:2.4; overflow-x: visible;"
    >
        <div [class.loading]="queryIsRunning" class="bg-white dark:bg-gray-800 dark:text-gray-300">
            <mtx-grid
                    (cellSelectedChange)="onCellSelectionChange($event)"
                    (columnChange)="columnChange($event)"
                    (page)="handlePage($event)"
                    (rowClick)="rowClik($event)"
                    (rowSelectedChange)="onRowSelectionChange($event)"
                    [showColumnMenuButton]="false"
                    (sortChange)="sortChange($event)"
                    [cellTemplate]="{actions: actionsTpl,index: iTpl, sn:iTpl, sno:iTpl, no:iTpl}"
                    [columnHideable]="columnHideable"
                    [columnPinnable]="columnPinnable"
                    [columnResizable]="columnResizable"
                    [columnSortable]="columnSortable"
                    [columns]="columns"
                    [contentEditable]="contentEditable"
                    [data]="listData?.data"
                    [expandable]="expandable"
                    [expansionTemplate]="expansionTpl"
                    [hideRowSelectionCheckbox]="hideRowSelectionCheckbox"
                    [length]="dataLength"
                    [loading]="queryIsRunning"
                    [multiSelectable]="multiSelectable"
                    [pageIndex]="pageIndex"
                    [pageOnFront]="!isPageable"
                    [pageSizeOptions]="pageSizeOptions"
                    [pageSize]="pageSize"
                    [rowClassFormatter]="rowClassFormatter"
                    [rowHover]="rowHover"
                    [rowSelectable]="rowSelectable"
                    [rowStriped]="rowStriped"
                    [showPaginator]="showPaginator"
                    [showToolbar]="showToolbar"
                    [toolbarTemplate]="toolbarTemplate"
                    [toolbarTitle]="title"
            ></mtx-grid>
        </div>
    </div>

    <!-- Toggle Controls -->
    <div
            (click)="toggleControls()"
            class="position-absolute box-20 m-1 me-2 top-right bg-hover-gradient-faded bg-none round cursor-pointer animate dark:bg-gray-700 dark:text-white"
    ></div>
</div>

<!-- index column -->
<ng-template #iTpl let-index="index" let-row>
  <span class="faded dark:text-gray-400">
    {{ index + 1 + pageIndex * pageSize }}
  </span>
</ng-template>
<!-- row expansion contents -->
<ng-template #expansionTpl let-col="colDef" let-index="index" let-row>
    <div class="ms-4 ms-lg-4 p-3 dark:bg-gray-800 dark:text-gray-300">
        <ng-container
                [ngTemplateOutletContext]="{data: row }"
                [ngTemplateOutlet]="expansion"
        ></ng-container>
    </div>
</ng-template>
<!-- Action Column -->
<ng-template #actionsTpl let-col="colDef" let-index="index" let-row>
    <ng-container
            [ngTemplateOutletContext]="{data: row, index:index, col:col }"
            [ngTemplateOutlet]="actions"
            class="dark:bg-gray-800 dark:text-gray-300"
    ></ng-container>
</ng-template>
<!-- Data Loading -->
<ng-template #noDataTpl>
    <ng-container *ngIf="!queryIsRunning; else loadingTmpl">
        <div
                class="my-lg-4 my-3 {{animation}} rounded-medium glass-2 rounded-slight overflow-hidden p-5 box-shadow-faded dark:bg-gray-800 dark:text-gray-300"
                style="--order:1.5"
        >
            <app-no-content
                    [icon]="icon"
                    [title]="noDataLabel ?? ('No ' + title)"
                    class="max-width-680 mx-auto bg-gradient-very-faded dark:bg-gray-700"
            ></app-no-content>
        </div>
    </ng-container>
</ng-template>
<!--Loading Animation for the table-->
<ng-template #loadingTmpl>
    <app-loading-content
            animation="animation"
            class="dark:bg-gray-800 dark:text-gray-300"
    ></app-loading-content>
</ng-template>
<!--ToolBar For The DataTable-->
<ng-template #toolbarTemplate>
    <div class="flex flex-wrap items-center dark:bg-gray-800 dark:text-gray-300">
        <!-- Data Count -->
        <data-label
                [label]="dataLength"
                [order]="2.5"
                icon="numbers"
                toolTip="Total Available Records"
                class="text-gray-300"
        ></data-label>

        <!-- Page Index -->
        <data-input
                (change)="setPageIndex($event)"
                [order]="2.5"
                [value]="displayedPageIndex"
                label="Page"
                maxWidth="80px"
                subLabel="({{ pagesLength | toFixed | round }})"
                toolTip="Set in Page Number"
                type="number"
                class="dark:bg-gray-800 dark:text-gray-300"
        ></data-input>

        <!-- Page Size -->
        <data-input
                (change)="setPageSize($event)"
                [order]="3"
                [value]="pageSize"
                label="Size"
                maxWidth="90px"
                toolTip="Fill in Page Size"
                type="number"
                class="dark:bg-gray-800 dark:text-gray-300"
        ></data-input>

        <!-- Export Data -->
        <data-input
                (labelClick)="exportExel()"
                *ngIf="canExportData && (dataLength || hasActiveStates())"
                [options]="allFieldsKeys"
                [order]="4.5"
                [value]="selectedExportKeys"
                icon="excel"
                labelToolTip="Export Excel"
                toolTip="Select Exported Fields"
                type="select"
                class="dark:bg-gray-800 dark:text-gray-300"
        ></data-input>

        <!-- Change Columns -->
        <data-input
                (change)="changeDisplayedColumns($event)"
                *ngIf="canChangeDisplayedColumns && allFieldsKeys.length || true"
                [options]="allFieldsKeys"
                [order]="5"
                [value]="selectedColumnsKeys"
                icon="table"
                labelToolTip="Change Displayed Columns"
                toolTip="Select Displayed Columns"
                type="select"
                class="dark:bg-gray-800 dark:text-gray-300"
        ></data-input>
    </div>
</ng-template>